module.exports = __webpack_public_path__ + "static/img/花瓶8.510ef21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶8.png
// module id = q3Kq
// module chunks = 2